import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1 text-left" }
const _hoisted_2 = { class: "text-xl font-bold text-textPrimary" }
const _hoisted_3 = { class: "text-sm text-[#52526f]" }
const _hoisted_4 = {
  class: "flex flex-col gap-4 text-left",
  "data-testid": "reject-document-modal"
}
const _hoisted_5 = { class: "flex flex-col gap-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-textPrimary" }, [
  /*#__PURE__*/_createTextVNode(" Motivo(s) da reprovação "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-negative" }, "*")
], -1)
const _hoisted_7 = {
  key: 0,
  class: "text-xs text-negative",
  "data-testid": "reject-reasons-error"
}
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col gap-1"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-bold text-textPrimary" }, [
  /*#__PURE__*/_createTextVNode(" Descreva o motivo "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-negative" }, "*")
], -1)
const _hoisted_10 = {
  key: 0,
  class: "text-xs text-negative",
  "data-testid": "reject-other-error"
}
const _hoisted_11 = { class: "flex flex-col gap-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-bold text-textPrimary" }, "Orientação ao médico (opcional)", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "rounded-lg bg-[#f0f0f4] p-3 text-xs text-[#52526f]" }, [
  /*#__PURE__*/_createTextVNode(" O documento volta para "),
  /*#__PURE__*/_createElementVNode("b", null, "Pendente"),
  /*#__PURE__*/_createTextVNode(". O médico vê o motivo e a orientação no Drive e recebe um push. Você pode desfazer a decisão depois. ")
], -1)
const _hoisted_14 = { class: "flex flex-col sm:flex-row sm:justify-end gap-3" }

import { ref, watch } from 'vue'

import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import Checkbox from '@/components/designSystem/Checkbox/index.vue'
import TextareaInput from '@/components/designSystem/Textarea/TextareaInput.vue'
import { REJECTION_REASON_OPTIONS } from '@/components/ProfessionalDocuments/labels'
import type { DecisionTarget } from '@/pinia-store/useDocumentReviewStore'
import { ProfessionalDocumentRejectionReason } from '@/types/professional-documents.types'
import type { RejectVersionPayload } from '@/types/professional-documents.types'

import { buildRejectPayload, validateRejectForm } from '../model'
import type { RejectForm } from '../model'

export interface RejectModalItem {
  versionId: number
  userId: number
  documentName: string
  professionalName: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RejectDocumentModal',
  props: {
    modelValue: { type: Boolean },
    items: {},
    isSaving: { type: Boolean }
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit }) {

const props = __props;




const emptyForm = (): RejectForm => ({ reasons: [], otherReason: '', guidance: '' })
const form = ref<RejectForm>(emptyForm())
const errors = ref<{ reasons?: string; other?: string }>({})

// Cada abertura começa sem motivos: o lote seguinte não herda a reprovação anterior.
watch(
  () => props.modelValue,
  (open) => {
    if (!open) return
    form.value = emptyForm()
    errors.value = {}
  },
  { immediate: true }
)

/** Payload do `Checkbox` do design system: `{ isChecked, value }`. */
function toggleReason(
  reason: ProfessionalDocumentRejectionReason,
  { isChecked }: { isChecked: boolean }
) {
  const current = form.value.reasons.filter((value) => value !== reason)
  form.value.reasons = isChecked ? [...current, reason] : current
}

function confirm() {
  errors.value = validateRejectForm(form.value)
  if (errors.value.reasons || errors.value.other) return
  emit(
    'confirm',
    props.items.map((item) => ({ versionId: item.versionId, userId: item.userId })),
    buildRejectPayload(form.value)
  )
}

function close() {
  emit('update:modelValue', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-[560px]",
    onClose: close
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.items.length > 1 ? `Reprovar ${_ctx.items.length} documentos` : 'Reprovar documento'), 1),
        _createElementVNode("p", _hoisted_3, [
          (_ctx.items.length === 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.items[0].documentName) + " · " + _toDisplayString(_ctx.items[0].professionalName), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("Os mesmos motivos valem para todos os selecionados.")
              ], 64))
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(OutlineButton, {
          text: "Cancelar",
          width: "120px",
          height: "40px",
          "data-testid": "reject-document-cancel",
          onClick: close
        }),
        _createVNode(FilledButton, {
          text: _ctx.items.length > 1 ? `Reprovar ${_ctx.items.length}` : 'Confirmar reprovação',
          class: "bg-negative",
          width: "220px",
          height: "40px",
          loading: _ctx.isSaving,
          disabled: _ctx.isSaving,
          "data-testid": "reject-document-confirm",
          onClick: confirm
        }, null, 8, ["text", "loading", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(REJECTION_REASON_OPTIONS), (option) => {
            return (_openBlock(), _createBlock(Checkbox, {
              key: option.value,
              "field-id": `reject-reason-${option.value}`,
              "data-testid": `reject-reason-${option.value}`,
              label: option.label,
              value: option.value,
              checked: form.value.reasons.includes(option.value),
              "onUpdate:checked": ($event: any) => (toggleReason(option.value, $event))
            }, null, 8, ["field-id", "data-testid", "label", "value", "checked", "onUpdate:checked"]))
          }), 128)),
          (errors.value.reasons)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errors.value.reasons), 1))
            : _createCommentVNode("", true)
        ]),
        (form.value.reasons.includes(_unref(ProfessionalDocumentRejectionReason).OTHER))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(TextareaInput, {
                modelValue: form.value.otherReason,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.otherReason) = $event)),
                rows: 2,
                maxlength: 500,
                placeholder: "Ex.: o nome no documento não confere com o cadastro",
                "data-testid": "reject-other-input"
              }, null, 8, ["modelValue"]),
              (errors.value.other)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(errors.value.other), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(TextareaInput, {
            modelValue: form.value.guidance,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.guidance) = $event)),
            rows: 3,
            maxlength: 1000,
            placeholder: "Ex.: envie o PDF original, com frente e verso",
            "data-testid": "reject-guidance-input"
          }, null, 8, ["modelValue"])
        ]),
        _hoisted_13
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})